<template>
  <div class="animated fadeIn">
    <CModal
      :show.sync="showModal"
      color="dark"
      accent-color="primary"
      >
      <template #header>
        <h5 class="modal-title">{{ title }}</h5>
        <CButtonClose @click="$emit('cancel')" class="text-white"/>
      </template>

      <!-- <p v-if="isText">{{ content }}</p>
      <span v-else v-html="rawHtml"></span> -->

      <p v-if="content">{{ content }}</p>

      <slot></slot>

      <template #footer>
        <CButton @click="$emit('cancel')" color="outline-dark">{{ cancelText }}</CButton>
        <CButton @click="$emit('confirm')" color="primary">{{ confirmText }}</CButton>
      </template>
    </CModal>

  </div>

</template>

<script>
export default {
  name:'ConfirmationModal',
  props: {
    show: {type: Boolean, default: false },

    title: {type: String, default: 'Confirmar'},

    confirmText: {type: String, default: 'Aceptar'},
    cancelText: {type: String, default: 'Cancelar'},

    isText: {type: Boolean, default: true },
    content: {type: String},
    rawHtml: {type: String},
  },
  data() {
    return {

    }
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function (newValue) {
        this.$emit("update:show", newValue)
      }
    }
  },

}
</script>
